module.exports = new __parcel__URL__("22607_h.66ee0f8c.jpg").toString();